import { type ReactNode } from 'react';
import { UserSubscriptionType } from '../services/subscriptions/subscriptions.types';
import { UserPlanType } from '../hooks/useUserSubscription/useUserSubscription.types';
import { Entitlement } from '@frontegg/nextjs';

export type UserEntitlementsContextType = {
  plan: UserSubscriptionType | undefined;
  isPaidUser: boolean;
  userPlanType: UserPlanType | undefined;
  isLoading: boolean;
  isSuccess: boolean;
  isUpgradeButtonVisible: boolean;
  isSubscriptionTabVisible: boolean;
  hasProPlanSubscription: boolean;
  isTrustedCustomer: boolean;
  useFeatureEntitlements: (featureKey: FronteggFeatureKeys) => Entitlement;
  usePermissionEntitlements: (
    permissionKey: FronteggPermissionKeys,
  ) => Entitlement;
  usePatientFeatureEntitlements: (
    featureKey: FronteggFeatureKeys,
  ) => Entitlement;
  usePatientPermissionEntitlements: (
    permissionKey: FronteggPermissionKeys,
  ) => Entitlement;
};

export enum FronteggFeatureKeys {
  ProPlan = 'pro-plan-feature',
  PremiumPlan = 'premium-feature',
  DayPass = 'day-pass-feature',
  SubscriptionManagement = 'subscription-management-feature',
  TrustedCustomer = 'trusted-customer-feature',
  CustomRoomInvite = 'custom-room-invite-feature',
  ProPlanSubscription = 'pro-plan-subscription-feature',
  Passcode = 'passcode-feature',
  Branding = 'branding-feature',
  PatientTransfer = 'patient-transfer-feature',
  UseNativeRooms = 'use-native-rooms',
}

export enum FronteggPermissionKeys {
  CancelSubscription = 'cancel-subscription-permission',
  AppUser = 'app-user',
  AppAdmin = 'app-admin',
  AppOwner = 'app-owner',
}

export type InternalProviderProps = {
  children: ReactNode;
};

export type UserEntitlementsProviderProps = InternalProviderProps & {
  isAuthenticated: boolean;
};
